import React from 'react';

export const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/5521996772772"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 left-6 z-50 flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
      aria-label="Fale conosco pelo WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.904 15.904 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.335 22.594c-.39 1.1-1.932 2.014-3.164 2.28-.844.18-1.946.322-5.66-1.216-4.748-1.966-7.806-6.778-8.04-7.094-.226-.316-1.9-2.53-1.9-4.826s1.2-3.424 1.628-3.892c.39-.426 1.02-.638 1.624-.638.196 0 .372.01.53.018.428.018.642.044.924.716.354.84 1.216 2.962 1.322 3.178.108.216.216.504.072.786-.136.29-.254.47-.47.724-.216.254-.452.566-.646.76-.216.216-.44.452-.19.886.254.428 1.126 1.856 2.418 3.008 1.66 1.48 3.06 1.938 3.494 2.154.434.216.688.18.94-.108.26-.29 1.1-1.278 1.392-1.718.29-.434.578-.362.976-.216.398.144 2.526 1.192 2.96 1.408.434.216.722.326.83.504.108.178.108 1.028-.282 2.128z"/>
      </svg>
      <span className="absolute left-16 bg-gray-800 text-white text-sm px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
        Fale conosco
      </span>
    </a>
  );
};
